import { createTracker } from '@ezcater/tracker-js'
import eventDictionary from './event_dictionary.json'
import { ezGlobals } from '../ez_globals'
import {
  eventPropertiesFromServerRequest,
  getEventPropertiesDefaultsFromName,
} from './event_properties_utils'

const rudderstackConfig = {
  configUrl: document.head.querySelector("meta[name='rudderstack_config_url']")?.content,
  pluginsSDKBaseURL: document.head.querySelector("meta[name='rudderstack_plugins_sdk_base_url']")?.content,
  destSDKBaseURL: document.head.querySelector("meta[name='rudderstack_dest_sdk_base_url']")?.content,
};

const trackerController = createTracker(eventDictionary, {
  ssr: true,
  trackingId: ezGlobals.trackingId,
  rudderstackDataPlaneUrl: document.head.querySelector("meta[name=rudderstack_data_plane_url_js]")?.content,
  rudderstackFFEnabled: document.head.querySelector("meta[name=rudderstack_ff_enabled]")?.content,
  rudderstackWriteKey: document.head.querySelector("meta[name=rudderstack_write_key]")?.content,
  rudderstackConfig: rudderstackConfig,
})

export const trackerJsClient = (trackerName, eventPropertiesDispatched = {}) => {
  const miscJsonProperties = {
    ...eventPropertiesFromServerRequest.misc_json,
    ...eventPropertiesDispatched.misc_json,
  }

  return trackerController.track(trackerName, {
    ...getEventPropertiesDefaultsFromName(trackerName),
    ...eventPropertiesFromServerRequest,
    ...eventPropertiesDispatched,
    misc_json: JSON.stringify(miscJsonProperties),
    source: 'javascript',
  })
}
